import { push } from 'react-router-redux';
import { toast } from "react-toastify";
const accountConstants = {
    ACCOUNT_LOGIN_REQUEST: 'ACCOUNT_LOGIN_REQUEST',
    ACCOUNT_LOGIN_RESPONSE: 'ACCOUNT_LOGIN_RESPONSE',
    ACCOUNT_CLEAR_AUTH: 'ACCOUNT_CLEAR_AUTH',
    HANDLE_TOGGLE: 'HANDLE_TOGGLE',
    EXTERNAL_REQUEST: 'EXTERNAL_REQUEST',
    EXTERNAL_RESPONSE: 'EXTERNAL_RESPONSE',
    ACCOUNT_NEW_PASS_REQUEST: 'ACCOUNT_NEW_PASS_REQUEST',
    ACCOUNT_NEW_PASS_SUCCESS: 'ACCOUNT_NEW_PASS_SUCCESS',
    ACCOUNT_NEW_PASS_ERROR: 'ACCOUNT_NEW_PASS_ERROR'
};

const initialState = {
    isLoading: false, isAuth: false, user: {}, toggleMenu: false, isProcessing: false
};

export const actionCreators = {
    requestAccountLogin: (email, pass) => async (dispatch, getState) => {
        dispatch({ type: accountConstants.ACCOUNT_LOGIN_REQUEST });
        const url = `api/Account/token`;
        return fetch(url, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8', 'Accept': 'application/json',
                'Authorization': `Basic ${email}:${pass}`
            }
        })
            .then(handleResponse)
            .then(token => {
                if (token) {
                    var jwt = token[0];
                    var name = token[1];
                    var userType = token[2];
                    var user = { email, token: jwt, name, userType };
                    localStorage.setItem('authToken', JSON.stringify(user));
                    dispatch({ type: accountConstants.ACCOUNT_LOGIN_RESPONSE, user, isAuth: true });
                }

                return user.token;
            },
                error => {
                    dispatch({ type: accountConstants.ACCOUNT_LOGIN_RESPONSE, isAuth: false });
                    return error;
                }
            );
    },
    forgotPassword: (email) => async (dispatch, getState) => {
        const url = `api/Account/forgotPasswordSendMail`;
        dispatch({ type: accountConstants.ACCOUNT_NEW_PASS_REQUEST, isProcessing: true });
        return fetch(url, {
            method: 'post',
            headers: {
                //'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json; charset=UTF-8',
                'Accept': 'application/json',
            },
            body: JSON.stringify({
                "mail": email,
            })
        })
            .then(handleResponse)
            .then(result => {
                dispatch({ type: accountConstants.ACCOUNT_NEW_PASS_SUCCESS, isProcessing: false });
                toast.success("We send a mail to reset the password!", {
                    position: toast.POSITION.TOP_RIGHT,
                });
                return result;
            },
                error => {
                    dispatch({ type: accountConstants.ACCOUNT_NEW_PASS_ERROR, isProcessing: false });
                    toast.error("Please Check Mail Address !", {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                    return error;
                })
    },
    saveNewPassword: (code, mail, password) => async (dispatch, getState) => {
        const url = `api/Account/saveNewPassword`;
        return fetch(url, {
            method: 'post',
            headers: {
                //'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json; charset=UTF-8',
                'Accept': 'application/json',
            },
            body: JSON.stringify({
                "code": code,
                "mail": mail,
                "password": password
            })
        })
            .then(handleResponse)
            .then(result => {
                toast.success("Success New Password!", {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    onClose: () => {
                        dispatch(push('/'));
                    }
                });
                return result;
            },
                error => {
                    toast.warn("Error !", {
                        position: toast.POSITION.BOTTOM_RIGHT,
                    });
                    return error;
                })
    },
    redirectToHome: () => async (dispatch, getState) => {

        if (getState().account.isAuth && getState().account.user && getState().account.user.userType === "FactoringContact") {
            dispatch(push("/factoring"));
        }
        else if (getState().account.isAuth && getState().account.user) {
            dispatch(push('/'));
        }
    },
    clearUser: () => async (dispatch, getState) => {
        if (localStorage.getItem("authToken")) {
            localStorage.removeItem("authToken");
            dispatch({ type: accountConstants.ACCOUNT_CLEAR_AUTH });
        }
    },
    clearSearch: () => async (dispatch, getState) => {

    },
    getUser: () => async (dispatch, getState) => {
        return getState().account.user;
    },
    handleToggle: (toggleValue) => async (dispatch, getState) => {
        dispatch({ type: accountConstants.HANDLE_TOGGLE, updateToggle: toggleValue });
    },
    getExtOpDetails: (ref) => async (dispatch, getState) => {
        const url = 'api/ExternalOperation/GetDetails/' + ref;
        dispatch({ type: accountConstants.EXTERNAL_REQUEST });
        fetch(url, {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getState().account.user.token
            },
        })
            .then(handleResponse)
            .then(
                result => {
                    if (result) {
                        if (result.jwt) {
                            var user = {
                                email: result.email,
                                token: result.jwt,
                                name: result.name
                            };
                            localStorage.setItem('authToken', JSON.stringify(user));
                            dispatch({ type: accountConstants.EXTERNAL_RESPONSE, user, isAuth: true });
                            dispatch(push(result.redirect));
                        }
                        else if (result.redirect) {
                            dispatch(push(result.redirect));
                        }
                    } else {
                        dispatch(push('/login'));
                    }
                },
                error => {
                    if (error.status === 401) {
                        dispatch(push('/login'));
                    } else {
                        toast.warn("Error:" + error.error, {
                            position: toast.POSITION.BOTTOM_RIGHT,
                        });
                    }
                });
    }
};

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            const error = { text, statusCode: response.status };
            return Promise.reject(error);
        }
        return data;
    });
}

export const reducer = (state, action) => {
    state = state || initialState;
    if (action.type === accountConstants.ACCOUNT_LOGIN_REQUEST) {
        return {
            ...state,
            isLoading: true
        };
    }

    if (action.type === accountConstants.ACCOUNT_LOGIN_RESPONSE) {
        return {
            ...state,
            isLoading: false,
            isAuth: action.isAuth,
            user: action.user
        };
    }

    if (action.type === accountConstants.ACCOUNT_CLEAR_AUTH) {
        return {
            ...state,
            isLoading: false,
            isAuth: false,
            user: {}
        };
    }
    if (action.type === accountConstants.HANDLE_TOGGLE) {
        return {
            ...state,
            toggleMenu: action.updateToggle
        };
    }

    if (action.type === accountConstants.EXTERNAL_REQUEST) {
        return {
            ...state,
            isLoading: true,
        };
    }

    if (action.type === accountConstants.EXTERNAL_RESPONSE) {
        return {
            ...state,
            isLoading: false,
            isAuth: action.isAuth,
            user: action.user
        };
    }
    if (action.type === accountConstants.ACCOUNT_NEW_PASS_REQUEST) {
        return {
            ...state,
            isProcessing: true
        };
    }
    if (action.type === accountConstants.ACCOUNT_NEW_PASS_SUCCESS) {
        return {
            ...state,
            isProcessing: false
        };
    }
    if (action.type === accountConstants.ACCOUNT_NEW_PASS_ERROR) {
        return {
            ...state,
            isProcessing: false
        };
    }
    return state;
};



// WEBPACK FOOTER //
// ./src/store/AccountStore.js